var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgJob = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6652 0.666504V1.99984H10.6652V0.666504H11.9985V1.99984H14.6652C15.0334 1.99984 15.3319 2.29832 15.3319 2.6665V13.3332C15.3319 13.7014 15.0334 13.9998 14.6652 13.9998H2.6652C2.29702 13.9998 1.99854 13.7014 1.99854 13.3332V2.6665C1.99854 2.29832 2.29702 1.99984 2.6652 1.99984H5.33187V0.666504H6.6652ZM13.9985 7.33317H3.33187V12.6665H13.9985V7.33317ZM5.33187 3.33317H3.33187V5.99984H13.9985V3.33317H11.9985V4.6665H10.6652V3.33317H6.6652V4.6665H5.33187V3.33317Z",
    fill: "#A3A3A3"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgJob, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/job.3d36a104.svg";
export { ForwardRef as ReactComponent };